import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home/MemoHeroSectionV2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/layout/MemoWrapper.tsx");
